import React from 'react'
import styles from './styles.module.scss'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import { setPreview } from '../../actions/helper'




const Preview = () => {
  
  const dispatch = useDispatch()
  const link = useSelector(state => state.preview)
  
  const closeModal = () => dispatch(setPreview(null))
  
  const pdfMode = link?.toLowerCase().includes('pdf')

  return (
    <Modal
      open={!!link}
      onClose={closeModal}
      classNames={{ modal: styles.modal }}
      showCloseIcon={false}
      animationDuration={1}
    >
      {pdfMode ? (
        <iframe
          src={link}
          title="PDF Preview"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      ) : (
        <img
          src={link}
          alt="Preview"
        />
      )}
    </Modal>
  )
}

export default Preview